<template>
   <tool-select-wrapper 
      label="BAT"
      icon-url="/static/icons/tools/pin.svg"
      :selected="batIsSelected"
      @click="handleClick">
      <tool-select-item
         v-for="tool in batTools"
         :key="tool.id"
         :tool="tool"
         @click="selectTool(tool.id)"
      />
   </tool-select-wrapper>
</template>

<script>
import ToolSelectItem from '../MapToolSelectItem';
import ToolSelectWrapper from '../ToolSelectWrapper';
import { mapGetters,mapActions } from 'vuex';
import { selectPointTool, selectPolygonTool, resetTools as resetBatTools } from '@/js/tools/bat';
import { BAT } from '@/store/modules/tools';

const batTools = [
   {
      id: 'bat-point',
      title: 'BY POINT',
      iconURL:'/icons/tools/location.svg',
      description: 'This will provide point based analysis and display result in bottom of the page.'
   },
   {
      id: 'bat-polygon',
      title: 'BY POLYGON',
      iconURL:'/icons/tools/polygon.svg',
      description: 'This will provide polygon based analysis and display result in bottom of the page.'
   },
];

export default {
   components: {
      ToolSelectWrapper,
      ToolSelectItem,
   },
   data() {
      return {
         batTools,
      }
   },
   computed: mapGetters('tools', ["batIsSelected",]),
   watch: {
      batIsSelected(isSelected)
      {
         if (!isSelected) resetBatTools();
      }
   },
   methods: {
      ...mapActions('tools', ["setCurrentTool", "clearResults"]),
      selectTool(toolId)
      {
         switch (toolId)
         {
            case 'bat-point':
               selectPointTool();
               break;
            case 'bat-polygon':
               selectPolygonTool();
               break;
            default:
               console.error(`Invalid toolId${toolId}`);
         }
      },
      handleClick()
      {
         this.setCurrentTool(BAT);
      }
   },
   beforeDestroy()
   {
      resetBatTools();
      this.clearResults({bat:true});
   }
}
</script>
